import { render, staticRenderFns } from "./ScoreModal.vue?vue&type=template&id=5c0ea3c4&scoped=true"
import script from "./ScoreModal.vue?vue&type=script&lang=js"
export * from "./ScoreModal.vue?vue&type=script&lang=js"
import style0 from "./ScoreModal.vue?vue&type=style&index=0&id=5c0ea3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0ea3c4",
  null
  
)

export default component.exports